"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
class ControllerCompositionGisAreas {
    constructor(gisAreas) {
        this.gisAreas = gisAreas;
    }
    filterByParams(param) {
        let gisAreasFilter = [];
        if (param.length > 0) {
            gisAreasFilter = this.gisAreas
                .filter((area) => area.areaName.toLowerCase().includes(param.toLowerCase()) ||
                area.category.toLowerCase().includes(param.toLowerCase()) ||
                area.crop.crop_name.toLowerCase().includes(param.toLowerCase()) ||
                area.gis_area_id.toString().includes(param))
                .map((sam) => sam);
        }
        else {
            gisAreasFilter = this.gisAreas;
        }
        return gisAreasFilter;
    }
}
exports.default = ControllerCompositionGisAreas;
